export default __webpack_public_path__ + "static/media/question.8761dc0e.svg";